<template>
  <!-- 促销规则管理 -->
  <div class="focusBuy">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['促销管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd('')"
          >新增集采活动</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="活动状态"
          style="width: 100px; margin-right: 5px"
          clearable
        >
          <el-option label="全部" value="99"></el-option>
          <el-option label="上架中" value="1"></el-option>
          <el-option label="未上架" value="0"></el-option>
          <el-option label="已达标" value="2"></el-option>
          <el-option label="未达标" value="-1"></el-option>
        </el-select>
        <el-input
          v-model="searchForm.name"
          style="width: 150px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="name"
        show-overflow-tooltip
        label="活动名称"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="goodsId"
        show-overflow-tooltip
        label="商品ID"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="goodsName"
        show-overflow-tooltip
        label="商品名称"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="price"
        show-overflow-tooltip
        label="活动单价"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="deposit"
        show-overflow-tooltip
        label="单份定金"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="startTime"
        show-overflow-tooltip
        label="活动开始时间"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="endTime"
        show-overflow-tooltip
        label="活动结束时间"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="targetType"
        show-overflow-tooltip
        label="达成目标类型"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="goodsNum"
        show-overflow-tooltip
        label="目标商品数量"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="userNum"
        show-overflow-tooltip
        label="目标客户数量"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="orderMinNum"
        show-overflow-tooltip
        label="下单最小数量"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="isLadder"
        show-overflow-tooltip
        label="是否启用阶梯价格"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="des"
        show-overflow-tooltip
        label="备注"
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.status == 0">未上架</el-tag>
          <el-tag type="success" v-if="scope.row.status == 1">上架中</el-tag>
          <el-tag type="danger" v-if="scope.row.status == -1">未达标</el-tag>
          <el-tag v-if="scope.row.status == 2">已达标</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="160">
        <template slot-scope="scope">
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleAdd(scope.row.id)"
            v-show="scope.row.status != 1"
            >编辑</el-button
          >
          <el-button
            type="success"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 1, 'update')"
            v-show="scope.row.status == 0"
            >上架</el-button
          >
          <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 0, 'update')"
            v-show="scope.row.status == 1"
            >下架</el-button
          >
          <el-button
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 0, 'delete')"
            v-show="scope.row.status == 0"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "focusBuy",
  data() {
    return {
      /**表格数据 */
      // {
      //   id:"活动ID",
      //   name:"活动名称",
      //   goodsId:"商品ID",
      //   goodsName:"商品名称",
      //   price:"活动单价",
      //   deposit:"单份定金",
      //   startTime:"活动开始时间",
      //   endTime:"活动结束时间",
      //   targetType:"达成目标类型",
      //   goodsNum:"目标商品数量",
      //   userNum:"目标客户数量",
      //   orderMinNum:"下单最小数量",
      //   isLadder:"是否启用阶梯价格",
      //   des:"备注",
      //   status:"状态",
      // }
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      selectedList: [],
      /**搜索表单 */
      searchForm: {
        status: "99", // 方案状态
        name: "",
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    updata() {
      this.getTableData();
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "GetjicaiList",
        PageIndex: this.currPage,
        PageSize: this.pageSize,
        status: this.searchForm.status,
        strWhere: this.searchForm.name,
      };
      let proc = "Proc_Admin_jicai"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "jicai/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.tableData = [];
          if (res.flag == 0) {
            for (let i = 0; i < res.data.length; i++) {
              this.allPage = res.recordCount;
              this.tableData.push({
                id: res.data[i].id,
                name: res.data[i].jcname,
                goodsId: res.data[i].article_id,
                goodsName: res.data[i].sub_title,
                price: res.data[i].price,
                deposit: res.data[i].deposit,
                startTime: res.data[i].starttime,
                endTime: res.data[i].endtime,
                targetType: res.data[i].target_type,
                goodsNum: res.data[i].target_goods_num,
                userNum: res.data[i].target_customer_num,
                orderMinNum: res.data[i].min_goods_num,
                isLadder: res.data[i].use_jieti,
                des: res.data[i].remarks,
                status: res.data[i].status,
              });
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**点击新增/编辑 */
    handleAdd(id) {
      let prams = encodeURIComponent(JSON.stringify({ id: id }));
      this.$router.push({
        path: "addFocusBuy",
        query: {
          prams: prams,
        },
      });
    },
    changeStatus(row, status, sqlType) {
      let msg = "确定要执行操作吗?";
      let msgType = "info";
      if (status == 1) {
        msg = "确定上架吗?";
        msgType = "success";
      } else if (status == 0 && sqlType == "update") {
        msg = "确定下架吗?";
        msgType = "warning";
      } else if (status == 0 && sqlType == "delete") {
        msg = "确定删除吗?";
        msgType = "error";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: msgType,
      })
        .then(() => {
          let data = {
            type: "Updatejicai",
            id: row.id,
            status: status,
            sqltype: sqlType,
          };
          let proc = "Proc_Admin_jicai"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "jicai/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.focusBuy {
  width: 100%;
  height: 100%;
}
</style>
